import { Alert, Button, Divider, Space, Tag } from 'antd';
import { ColoredTags } from 'components/Dashboard/ColoredTags';
import gql from 'graphql-tag';
import { Link, useHistory } from 'react-router-dom';
import { useAuthedMutationWithNotification, useAuthedQuery } from 'utils/qlAuth';

export default function UniverseList() {
  const history = useHistory();
  const [UniverseController_createUniverse, UniverseController_createUniverseRes] = useAuthedMutationWithNotification(gql`
    mutation UniverseController_createUniverse($name: String!) {
      UniverseController_createUniverse(name: $name) {
        id
      }
    }
  `);

  const qUniverseList = useAuthedQuery(
    gql`
      query UniverseController_getUniverseList {
        UniverseController_getUniverseList {
          id
          name
          tags
          status
        }
      }
    `,
  );

  if (UniverseController_createUniverseRes?.data?.UniverseController_createUniverse?.id) {
    history.push(`/universe/${UniverseController_createUniverseRes.data?.UniverseController_createUniverse.id}/`);
  }

  const universes = qUniverseList.data?.UniverseController_getUniverseList || [];

  return (
    <>
      <Button
        onClick={async () => {
          await UniverseController_createUniverse({ variables: { name: `New universe` } });
        }}
      >
        Create Universe
      </Button>
      <Divider />
      <Space direction="vertical" style={{ width: '100%' }}>
        {universes.map(universe => (
          <Alert
            message={
              <Space direction="horizontal">
                <Tag>{universe.id}</Tag>
                <Link to={`/universe/${universe.id}/`}>
                  <b>{universe.name}</b>
                </Link>

                <ColoredTags tags={universe.tags} />
              </Space>
            }
          />
        ))}
      </Space>
    </>
  );
}
